<template>
  <div id="features" class="feature-section ptb-100" v-bind:class="{ 'gray-light-bg': isGray }">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-9 col-lg-9">
          <div class="section-heading text-center mb-5">
            <h2>Additional features</h2>
            <p></p>
          </div>
        </div>
      </div>

      <!--feature new style start-->
      <div class="row align-items-center justify-content-md-center">
        <div class="col-lg-4 col-md-12">
          <div class="row">
            <div class="col-12">
              <div class="d-flex align-items-start mb-sm-0 mb-md-3 mb-lg-3">
                <span class="ti-face-smile icon-size-md color-secondary mr-4"></span>
                <div class="icon-text">
                  <h5 class="mb-2">Ride Notes</h5>
                  <p>Provide your BBR driver with a pick-up note, information on your location or a pre-requested pick-up time. </p>
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="d-flex align-items-start mb-sm-0 mb-md-3 mb-lg-3">
                <span class="ti-vector icon-size-md color-secondary mr-4"></span>
                <div class="icon-text">
                  <h5 class="mb-2">Trip ID</h5>
                  <p>Keep track of your most recent rides with a Trip ID provided during every booking.</p>
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="d-flex align-items-start mb-sm-0 mb-md-3 mb-lg-3">
                <span class="ti-headphone-alt icon-size-md color-secondary mr-4"></span>
                <div class="icon-text">
                  <h5 class="mb-2">Chat with your driver from the APP</h5>
                  <p>Provide detailed information for your driver through our chat feature. </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-5 d-none d-sm-none d-md-block d-lg-block">
          <div class="position-relative pb-md-5 py-lg-0">
            <img
              alt="Image placeholder"
              src="../../assets/img/app-mobile-image.png"
              class="img-center img-fluid"
            />
          </div>
        </div>
        <div class="col-lg-4 col-md-12">
          <div class="row">
            <div class="col-12">
              <div class="d-flex align-items-start mb-sm-0 mb-md-3 mb-lg-3">
                <span class="ti-layout-media-right icon-size-md color-secondary mr-4"></span>
                <div class="icon-text">
                  <h5 class="mb-2">Call your driver</h5>
                  <p>Compellingly formulate installed base imperatives high standards in benefits for highly efficient client.</p>
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="d-flex align-items-start mb-sm-0 mb-md-3 mb-lg-3">
                <span class="ti-layout-cta-right icon-size-md color-secondary mr-4"></span>
                <div class="icon-text">
                  <h5 class="mb-2">Emergency contact</h5>
                  <p>Provide the contact information of a family member or friend to keep track of your ride in an emergency situation.</p>
                </div>
              </div>
            </div>
            <!-- <div class="col-12">
              <div class="d-flex align-items-start mb-sm-0 mb-md-3 mb-lg-3">
                <span class="ti-palette icon-size-md color-secondary mr-4"></span>
                <div class="icon-text">
                  <h5 class="mb-2">Infinite colors</h5>
                  <p>Energistically initiate client-centric e-tailers rather than-based data. Morph business technology before.</p>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
      <!--feature new style end-->
    </div>
  </div>
</template>

<script>
export default {
  name: "Features",
  props: {
    isGray: {
      type: Boolean,
      default: false
    },
  },
};
</script>

<style>
</style>